import { makeAutoObservable } from "mobx";

import { voiceToTextService } from "../api/voiceToTextService";
import { ITranscribeVoiceToTextParams } from "../types";

export class VoiceToTextStore {
  private _startRecordingCallback: (() => void) | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setStartRecordingCallback(cb: (() => void) | null) {
    this._startRecordingCallback = cb;
  }

  startRecording() {
    this._startRecordingCallback?.();
  }

  async transcribeVoiceToText(params: ITranscribeVoiceToTextParams) {
    const response = await voiceToTextService.transcribeVoiceToText(params);

    return response.text;
  }
}
